import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";

import vuetify from "./plugins/vuetify";

import StatusIndicator from "vue-status-indicator";

import BaseTitle from "./components/BaseComponent/BaseTitleBar";
import vMultiselectListbox from "vue-multiselect-listbox";

import "vue-multiselect-listbox/dist/vue-multi-select-listbox.css";
import "animate.css";

import JsonCSV from "vue-json-csv";

import titleMixin from "./mixins/titleMixin";

import VueGtag from "vue-gtag";

import {io} from "socket.io-client";
import wysiwyg from "vue-wysiwyg";

import {
    dayFormat,
    timeFormat,
    IsoToIst,
    IsoToUtc,
    dayFormatV2,
    unixTime,
    DatetimeFormat,
    UtcToEst,
} from "@/filters/day.js";

export const SocketInstance = io(process.env.VUE_APP_SOCKET_ENDPOINT);

Vue.use(StatusIndicator);
Vue.use(SocketInstance);
Vue.use(wysiwyg, {}); // config is optional. more below

Vue.use(VueGtag, {
    config: {id: "UA-204063830-2"},
    includes: [{id: "AW-323506423"}],
});

Vue.filter("dayFormat", dayFormat);
Vue.filter("timeFormat", timeFormat);
Vue.filter("IsoToIst", IsoToIst);
Vue.filter("IsoToUtc", IsoToUtc);
Vue.filter("dayFormatV2", dayFormatV2);
Vue.filter("unixTime", unixTime);
Vue.filter("DatetimeFormat", DatetimeFormat);
Vue.filter("UtcToEst", UtcToEst);

Vue.component("base-title-bar", BaseTitle);
Vue.component("v-multiselect-listbox", vMultiselectListbox);
Vue.component("downloadCsv", JsonCSV);

Vue.mixin(titleMixin);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
}).$mount("#app");
